/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MainRegionAndRiskTerritoryResponseDto
 */
export interface MainRegionAndRiskTerritoryResponseDto {
    /**
     * 
     * @type {number}
     * @memberof MainRegionAndRiskTerritoryResponseDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MainRegionAndRiskTerritoryResponseDto
     */
    regionName: string;
    /**
     * 
     * @type {string}
     * @memberof MainRegionAndRiskTerritoryResponseDto
     */
    country: string;
    /**
     * 
     * @type {boolean}
     * @memberof MainRegionAndRiskTerritoryResponseDto
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof MainRegionAndRiskTerritoryResponseDto
     */
    isoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof MainRegionAndRiskTerritoryResponseDto
     */
    status: string;
    /**
     * 
     * @type {Date}
     * @memberof MainRegionAndRiskTerritoryResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof MainRegionAndRiskTerritoryResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the MainRegionAndRiskTerritoryResponseDto interface.
 */
export function instanceOfMainRegionAndRiskTerritoryResponseDto(value: object): value is MainRegionAndRiskTerritoryResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('regionName' in value) || value['regionName'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function MainRegionAndRiskTerritoryResponseDtoFromJSON(json: any): MainRegionAndRiskTerritoryResponseDto {
    return MainRegionAndRiskTerritoryResponseDtoFromJSONTyped(json, false);
}

export function MainRegionAndRiskTerritoryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainRegionAndRiskTerritoryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'regionName': json['regionName'],
        'country': json['country'],
        'isActive': json['isActive'],
        'isoCode': json['isoCode'] == null ? undefined : json['isoCode'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function MainRegionAndRiskTerritoryResponseDtoToJSON(json: any): MainRegionAndRiskTerritoryResponseDto {
    return MainRegionAndRiskTerritoryResponseDtoToJSONTyped(json, false);
}

export function MainRegionAndRiskTerritoryResponseDtoToJSONTyped(value?: MainRegionAndRiskTerritoryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'regionName': value['regionName'],
        'country': value['country'],
        'isActive': value['isActive'],
        'isoCode': value['isoCode'],
        'status': value['status'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

